<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
          {"num_cand":"U2FsdGVkX19zSNanIV2n0bXZpdnO9edwKyTAnb5GLzE=","cpf":"U2FsdGVkX1+SrES3OmjBQnLC1qNeuW9Y+/z3w1Z5nR0="},{"num_cand":"U2FsdGVkX18OpXBNFClJAOlrPWailigy/D49REEBocc=","cpf":"U2FsdGVkX18PA8WVAEt9WIYkxr9+ObOASPSgpj7uuvI="},{"num_cand":"U2FsdGVkX1+3ZxyPgF3WSSl1gcV/FTXs8UsUNeVJd6k=","cpf":"U2FsdGVkX1/iJJZa9TBE9cZ3uuNTh0Pyt0mCFMbmXac="},{"num_cand":"U2FsdGVkX18U+wQIZsBwXMpcpuJAt1Vpq7VNcv6OumA=","cpf":"U2FsdGVkX1+Ojj7S0n0pwVVKPt7W0ZdDEP3+D4OCl0A="},{"num_cand":"U2FsdGVkX1+n1FMvIL/Dw2N9ajQYhnWGfYsEOi2Ps1g=","cpf":"U2FsdGVkX1/rx2I0ZIWsW/Hnh1IQicsXzqF1hSXSeBQ="},{"num_cand":"U2FsdGVkX1/qxGN+U341A36uhFp25nAvy8KVoxnlj74=","cpf":"U2FsdGVkX19RJp2ufyahUBluhpkL3iGYgwR/iwZFdg8="},{"num_cand":"U2FsdGVkX1+Yw0cm7JYmad4yjxdfYenEqpKSrzkfjsE=","cpf":"U2FsdGVkX19WEKIrWQcGIWrxDWktNpC1f2FhxNER+dk="},{"num_cand":"U2FsdGVkX1+Des7i+4IIi78m3s679OzS/r638OfQ5UA=","cpf":"U2FsdGVkX1/y2GH6ERGsvxKPwqRHKmLfj+oh+HYdyKs="},{"num_cand":"U2FsdGVkX19aaHlYLGFx6f7cpJKcCrewZg/ejIhNH6o=","cpf":"U2FsdGVkX18HnXqUmvHWdYDyZYvdMUBWYxJLzpu7/4M="},{"num_cand":"U2FsdGVkX1+r5vqFK5CMHdwAYye8o9keQ9UMV4f1mXk=","cpf":"U2FsdGVkX1+/u/pTvIIk0QtIF9BXRxe82yRpmkVRz7M="},{"num_cand":"U2FsdGVkX19OWy/yYJMKntSuOcfLfGtT2P4OL4Q8J4o=","cpf":"U2FsdGVkX19theGjr1FraG3jTm4YNWiqQ1OmHu9VXsI="},{"num_cand":"U2FsdGVkX18OWvYrMnoZiiPt+I1w+BVqKYT8RWn4iZo=","cpf":"U2FsdGVkX19fnWj7V5qIbh0QfRE4yn2zklbQH240ob8="},{"num_cand":"U2FsdGVkX18YRvKwlhiwcYNHplNcrpVuEW9O56p8gPA=","cpf":"U2FsdGVkX18323LddPwpJvDc9abAKxLRvWYBfKuUNak="},{"num_cand":"U2FsdGVkX18w5c3inF+Oi9oYRniR4WloFDRtIZ+Ug2A=","cpf":"U2FsdGVkX1+EABt+CXhaNpahLC6uMyHZi9wZ5ypYn1c="},{"num_cand":"U2FsdGVkX1/N8KtadQ52vx6YhSe0QKcVXbRPyieFHQI=","cpf":"U2FsdGVkX1+DHiKyqUy+n046C63IH8EcWsVWXRi1gUI="},{"num_cand":"U2FsdGVkX1+hooBxwUAJQBJDx6MmwFd41/4XC14MttE=","cpf":"U2FsdGVkX1/D8WZQq+RCkDLmwzjIxXWvTcSuLOOPHHo="},{"num_cand":"U2FsdGVkX1+MqsRDy3aOrKWMIDuDpdfWCpqezjAYJoY=","cpf":"U2FsdGVkX19WAxf1yW0KMgRW8U+okZIN611JanzLh2Y="},{"num_cand":"U2FsdGVkX19VBllSVWVxcRIIytbg36Jj3MEBRbx3Q14=","cpf":"U2FsdGVkX18htQ8ys1cpQcr2btY/3TpqYl0FfW8P/oA="},{"num_cand":"U2FsdGVkX19IYPFTs/6OU9zR00vM4AOxVfPWDImGWe0=","cpf":"U2FsdGVkX1+IKkXdF+su65RHUebooAUw2QiViy+yeMQ="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2208/2208_re_insc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
